'use client';
import { useEffect, useRef } from 'react';
import useShallowMemo from 'use-shallow-memo';
import useDatadogRum from './use-datadog-rum.js';
import useUser from './use-user.js';
export default function useDatadog({ enabled = true, sessionReplayRecording = true, site = 'datadoghq.com', user, ...rumInitConfiguration }) {
    const rum = useDatadogRum();
    const lastInitConfiguration = useRef(null);
    const rumInitConfigurationMemo = useShallowMemo({
        site,
        ...rumInitConfiguration,
    });
    useEffect(() => {
        if (!enabled) {
            return;
        }
        if (lastInitConfiguration.current === rumInitConfigurationMemo) {
            return;
        }
        lastInitConfiguration.current = rumInitConfigurationMemo;
        rum.init(rumInitConfigurationMemo);
    }, [enabled, rum, rumInitConfigurationMemo]);
    useEffect(() => {
        if (!enabled || !sessionReplayRecording) {
            return;
        }
        rum.startSessionReplayRecording();
        return () => {
            rum.stopSessionReplayRecording();
        };
    }, [enabled, rum, sessionReplayRecording]);
    useUser(user);
}
//# sourceMappingURL=use-datadog.js.map